import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
import SpriteSvg from "../common/svg";
import { ArticleType } from "@shared/url";
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { SearchResult } from "@shared/graphql";
import { useEffect, useRef, useState } from "react";
import ArticleCard from "../article-card";
import { useWishlist } from "../../contexts/wishlist";


type Props = {
  type : ArticleType
}

const ANY_SEARCH_GQL_DATA = gql`
  query SEARCH($where: AnyArticleFilterInput, $sort: AnyArticleSortInput, $first: Int, $last: Int, $before: String, $after: String) {
    search(where: $where, sort: $sort, first: $first, last: $last, before: $before, after: $after) {
      totalCount
      edges {
        cursor
        node {
          ... on RentalAccommodationArticle {
            id slug
            novelty recommended promoted
            images @limit(max: 10) { assets { url breakpoint } }
            address { city street }
            title { value }
            lowestPrice { type onDemand value }
            features { bedrooms bathrooms maxGuests}
          }
          ... on SeasonalAccommodationArticle {
            id slug
            novelty recommended promoted
            images @limit(max: 10) { assets { url breakpoint } }
            address { city street }
            title { value }
            seasonalPrice: price { onDemand value }
            features { bedrooms bathrooms maxGuests}
          }
          ... on AnnualAccommodationArticle {
            id slug
            novelty recommended promoted
            images @limit(max: 10) { assets { url breakpoint } }
            address { city street }
            title { value }
            annualPrice: price { onDemand value }
            features { bedrooms bathrooms }
          }
          ... on SaleAccommodationArticle {
            id slug
            novelty recommended promoted sold reserved
            images @limit(max: 10) { assets { url breakpoint } }
            address { city street }
            title { value }
            salePrice: price { onDemand value }
            features { bedrooms bathrooms }
          }
        }
      }
    }
  }
`;

const normalizeArticlePrice = (node: any) => {
  if (!node) return node;
  const { seasonalPrice, annualPrice, salePrice, ...article } = node;
  return {
    ...article,
    price: seasonalPrice ?? annualPrice ?? salePrice
  };
};

const determineArticleCarouselsType = (type: ArticleType) => {
  switch (type) {
      case ArticleType.RENTAL:
          return { rentalAccommodation: {} }
          break;
      case ArticleType.SEASONAL:
          return { seasonalAccommodation: {} }
          break;

      case ArticleType.ANNUAL:
          return { annualAccommodation: {} }
          break;

      case ArticleType.SALE:
          return { saleAccommodation: {} }
          break;
      default:
          return { rentalAccommodation: {} }
          break;
  }
};

const carousel_option = {
  pagination: false,
  perPage:3,
  perMove: 1,
  gap:"4rem",
  padding:"0px",
  breakpoints: {
    1200:{
      perPage:2,
      gap:"3rem",
    },
    576:{
      perPage:1,
      gap:"1rem",
    },
  },
}

const ArticleCarousel = ({type}:Props) => {

  const splideRef = useRef<any>(null);
  const [carouselKey, setCarouselKey] = useState(0);
  const pageSize = useRef<number>(8);
  const { popup } = useWishlist();
  const { data, loading } = useQuery<{ search: SearchResult }>(ANY_SEARCH_GQL_DATA, {
    ssr: false,
    variables: {
      first: pageSize.current,
      where: determineArticleCarouselsType(type)},
  });

  useEffect(() => {
    (!loading && data) && setCarouselKey(prev => prev + 1);
  }, [type, loading, data]);

  const handleMounted = (splide: any) => {
    splideRef.current = splide;
  };

  return(
    <>
      {popup()}
      <Splide hasTrack={ false } key={carouselKey} options={carousel_option} onMounted={handleMounted}>
        <div className="splide__arrows custom">
            <button className="splide__arrow splide__arrow--prev">
              <SpriteSvg id="chevron-right" />
            </button>
            <button className="splide__arrow splide__arrow--next">
              <SpriteSvg id="chevron-right" />
            </button>
        </div>
        <SplideTrack>
          {(data?.search.edges || Array.from({ length: pageSize.current })).map((edge: any, i: number) => {
            return(
              <SplideSlide key={edge?.node.id || i}>
                <ArticleCard loading={loading} data={normalizeArticlePrice(edge?.node)}/>
              </SplideSlide>
            );
          })}
      </SplideTrack>
      </Splide>
    </>
  );
}

export default ArticleCarousel;
